import {FC, useEffect} from 'react'
import {useParams} from 'react-router-dom'
import {Presenter} from './Presenter'
import {useLazyQuery} from 'hooks/graphql'
import {EGOV_PROCEDURE, QueryVariables, QueryResult} from './query'

export const Show: FC = () => {
  const {id} = useParams<{id: string}>()
  const [fetch, {loading, data}] = useLazyQuery<QueryResult, QueryVariables>(EGOV_PROCEDURE, {
    fetchPolicy: 'network-only',
  })

  const refetch = (egovProcedureId: string) => {
    fetch({variables: {egovProcedureId}})
  }

  useEffect(() => {
    if (id) {
      fetch({variables: {egovProcedureId: id}})
    }
  }, [id])

  return !loading && data ? <Presenter refetch={refetch} egovProcedure={data.client.egovProcedure} /> : <></>
}
